module.exports = __webpack_public_path__ + "static/media/SC.5168dd83.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SC.svg
// module id = 353
// module chunks = 0